import { render, staticRenderFns } from "./ItemDL_Item_Ref.vue?vue&type=template&id=49abc43a"
import script from "./ItemDL_Item_Ref.vue?vue&type=script&lang=js"
export * from "./ItemDL_Item_Ref.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports